export default __webpack_public_path__ + "static/media/PatientImg.ed297802.png";